import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "frame"
    ]

    static values = {iaConfirmModalUrl: String, iaAutoReplyUrl: String}
    client = null;

    #uniqUid
    #modalContext
    #modalClient

    connect() {
        console.log("ZenAppController connected");
        this.#uniqUid = crypto.randomUUID();
        this.client = ZAFClient.init();
        if (this.client) {
            this.client.invoke('resize', {width: '100%', height: '80vh'});
            this.getContext()
        }

        // Update browser history on turbo frame load so redirections from resource controller work fine and redirect to context frame
        document.addEventListener("turbo:frame-load", (event) => {
            const frame = event.target;
            const newUrl = frame.src;
            if (newUrl) {
                history.replaceState({}, '', newUrl);
            }
        });

        const channel = new BroadcastChannel(`ia-confirm-modal-${this.#uniqUid}`);

        channel.onmessage = ({data}) => {
            if (!this.#modalClient)
                return;
            const action = data.action
            if (action == "cancel") {
                this.#modalClient.invoke("destroy");
            } else {
                this.#modalClient.trigger("modal.confirm")
                this.#modalClient.invoke("destroy");
            }
        };
    }


    displayModal() {
        return new Promise((resolve) => {
            this.client.invoke('instances.create', {
                location: 'modal',
                url: this.iaConfirmModalUrlValue + `?uid=${this.#uniqUid}`,
                size: {
                    width: '300px',
                    height: '200px'
                }
            }).then((modalContext) => {
                this.#modalContext = modalContext
                var modalClient = this.client.instance(modalContext['instances.create'][0].instanceGuid);
                this.#modalClient = modalClient
                modalClient.on('modal.close', function () {
                    resolve('cancel');
                });
                modalClient.on('modal.confirm', function () {
                    resolve(true);
                });
            });
        });
    }

    getContext() {
        console.log("getContext called")
        this.client.get('ticket').then((async function (data) {
            // Récupérer l'ID du probleme lié à l'incident s'il existe
            let problemId
            let tickeTypeObj = await this.client.get('ticket.type')
            if (tickeTypeObj['ticket.type'] === 'incident') {
                let problemObj = await this.client.get('ticket.customField:problem_id')
                problemId = problemObj['ticket.customField:problem_id'];
            }

            // Id du ticket courant
            let ticketId = data.ticket.id;

            let userEmails = data.ticket.requester.identities.filter(identity => identity.type == "email").map(o => o["value"])

            // IMPORTANT : En contexte, on veut le problème lié à l'incident s'il existe, sinon on prend le ticket courant
            let contextTicketId = problemId || ticketId
            this.frameTarget.src = `/oqoro_admin/zendesk_app/sidebar/context?emails=${encodeURIComponent(userEmails)}&ticket_id=${encodeURIComponent(contextTicketId)}&problem_id=${encodeURIComponent(problemId)}`;

            this.client.get('comment.text').then((commentText) => {
                if (!commentText['comment.text']) {
                    // Recupere la reponse IA auto
                    this.fetchAutoReply(ticketId)
                }
            })
        }).bind(this))
    }

    fetchAutoReply(ticketId) {
        return fetch(`${this.iaAutoReplyUrlValue}?ticket_id=${ticketId}`)
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then(data => {
                if (data.message) {
                    this.client.set('comment.type', "publicReply")
                    this.client.set('comment.text', data.message)
                    this.client.on('ticket.save', async () => {
                        return this.client.get('comment.text').then(async (newText) => {
                            const htmlString = newText["comment.text"]
                            // Check si la reponse auto a ete modifiee
                            console.log("Reponse auto", htmlString, data.message)
                            if (htmlString == data.message) {
                                const userConfirmed = await this.displayModal();
                                if (userConfirmed === 'cancel') {
                                    throw new Error('Annulation de la sauvegarde');
                                } else {
                                    return "Sauvegarde en cours"
                                }
                            } else {
                                return true;
                            }
                        })
                    });
                }
            })
            .catch(error => {
                console.error("Fetch error:", error);
            });
    }
}
